// import VOPRoutes from './vop'

export default [
  // ...VOPRoutes
]
